import { useMemo, useCallback } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { ImageCollectionLayer, ImageSelectedLayer, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { NetworkReferentialLayer, useNavigateToLinearLocation } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADSIDE, APP_ROAD } from "../../../../common/constants/appRoad"
import { MODULE_ROADSIDE } from "../../../../common/constants/modules"
import { RoadRoadsideHomogenousZonesLayer } from "../../containers/RoadRoadsideHomogenousZonesLayer"
import { RoadsideLayer } from "../../containers/RoadsideLayer"

export function RoadsideMapLayersRouter() {

    const matchRoad = useMatch(`:slugId/${APP_ROAD}/${MODULE_ROADSIDE}/:road/*`)
    const isSegmentView = !!matchRoad
    const road = matchRoad?.params?.road ? decodeURIComponent(matchRoad.params.road) : null

    const navigateToLinearLocation = useNavigateToLinearLocation()
    const { setSegmentFeatureIdClicked } = useImageCollectionDispatchContext()

    const processNavigation = useCallback((feature, location, navigationOrigin) => {
        if (location && location.road && location.road !== road) {
            setSegmentFeatureIdClicked(feature?.properties?.uuid)
            navigateToLinearLocation(location, ".", { saveMapBoundingBox: !isSegmentView, paramsToRemove: [], navigationOrigin: navigationOrigin })
        }
    }, [setSegmentFeatureIdClicked,
        navigateToLinearLocation,
        isSegmentView,
        road])

    const roadworksMapRoutes = useMemo(() => ([
        {
            path: "/",
            element: <>
                <NetworkReferentialLayer module={API_MODULE_ROADSIDE} processNavigation={processNavigation} />
                <RoadsideLayer />
            </>,
        },
        {
            path: "/:road/*",
            element: <>
                <NetworkReferentialLayer module={API_MODULE_ROADSIDE} processNavigation={processNavigation} roadToHide={road} />
                <RoadsideLayer />
                <RoadRoadsideHomogenousZonesLayer road={road} />
                <ImageCollectionLayer road={road} />
                <ImageSelectedLayer />
            </>,
        },
    ]), [processNavigation, road])

    return useRoutes(roadworksMapRoutes)
}